module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "70px"
    }
  }, [_c('strong', [_vm._v("MARGARET")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Devoid of all thoughts, feelings, tears, laughter, and dreams; she was an empty shell.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("BREATHING")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("EXISTING")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("The net curtain slipped from her liver-spotted, gnarled hand. Slowly turning away, she hobbled back into the gloomy interior of the small, stuffy room.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("JOSHUA")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("His young, brooding eyes sharply switched from a group of rowdy teenagers to a distant, lone figure as she approached the school gates and walked through. One day, he silently vowed, I am going to make this girl my wife.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("ABIGAIL")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("From afar, she had spotted him as she had done yesterday, the day before yesterday, and a myriad of other mornings; always sitting in the same spot, furiously copying a mate’s homework while, surreptitiously, casting her an eye before, closing his exercise book, and joining his boisterous chums in a laugh and a bout of harmless play-fighting. Always the centre of attention, she mused. He was popular, confident, and too good-looking for his own good. Not her type at all. Abruptly, she looked away, lest, once more, he caught her eye. She certainly had no intention of being a fly in his web.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("The bell rang.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("The playground was empty.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-099ca8ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 75
// module chunks = 0